import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const MessageContainer = styled.div`
  ${tokens.flexCenter()};
  flex-direction: column;
  flex: 1;
  margin-top: ${tokens.spacer.x8};
  color: ${tokens.color.text_default};
`;

export const EmptyPageMessageContainer = styled(MessageContainer)<{ imgWidth?: number }>`
  max-width: 450px;
  margin: 0 auto;

  ${({ imgWidth }) =>
    imgWidth &&
    `
    img {
      min-width: ${imgWidth}px;
    }
  `}
`;
